<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  export let attribute
</script>

<svelte:window
  on:keydown|preventDefault={(event) => {
    if (event.key === "Enter") {
      dispatch("deleteLayer")
    }
  }}
/>

<div class="fixed inset-0 z-20 flex select-none flex-col items-center justify-center overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
  <div class="w-[500px]">
    <div class="w-full rounded-t-md bg-darkgray p-5">
      <div class="pb-7 text-center text-lg font-bold tracking-wide text-slate-100">Delete Layer</div>
      <p class="pb-5 text-center text-base font-medium leading-relaxed text-gray-600">
        Do you want to delete <strong class="truncate font-bold text-white">&nbsp;{attribute}&nbsp;</strong>
        Layer?
      </p>
    </div>
  </div>
  <div class="flex w-[500px] justify-evenly rounded-b-md bg-[#242424] px-5 py-3">
    <button on:click class="active:bg-green-g00 group flex h-9 w-1/4 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none">
      <span class="text-white">
        <i class="fa-solid fa-circle-xmark" />
      </span>
      <span class="select-none">&nbsp;&nbsp;No</span>
    </button>
    <button
      on:click={() => {
        dispatch("deleteLayer")
      }}
      class="active:bg-green-g00 group flex h-9 w-1/4 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none"
    >
      <span class="text-white">
        <i class="fa-solid fa-circle-check" />
      </span>
      <span class="select-none">&nbsp;&nbsp;Yes</span>
    </button>
  </div>
</div>
